export const CpbxThemeSelector = (context) => {
    const theme = context.theme ? context.theme : context;

    // another possibility is to add an additional variable or css property to the document.body
    // document.body.style.setProperty('filter','invert(100%)');
    // document.body.style.setProperty('--background-color','black');
    function cssAdd(href) {
        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.className = "defaultTheme";
        link.type = "text/css";
        link.href = href;
        document.head.appendChild(link);
    }
    function cssDel() {
        const elem = document.querySelector(".defaultTheme");
        console.log("delete Theme", elem);
        elem?.remove();
    }
    // switch (context?.theme) {
    switch (theme) {
        // case "default":
        //     cssAdd("/styles_themes/custom_theme_default.css");
        //     break;
        case "dark": {
            cssDel();
            cssAdd("/styles_themes/custom_theme_dark.css");
            break;
        }
        case "contrast": {
            cssDel();
            cssAdd("/styles_themes/custom_theme_contrast.css");
            break;
        }
        // case "default": ;
        default: {
            cssDel();
            cssAdd("/styles_themes/custom_theme_default.css");
            break;
        }
    }
};
